export const catchIsUserValid = user => {
  return (
    !!user &&
    !!user["https://coo-e.com/userId"] &&
    !!user["https://coo-e.com/userType"]
  )
}
